import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash/fp';
import cns from 'classnames';

import cn from './styles.local.less';

export default class CmsBlock extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    content: PropTypes.string,
    isDefaultStyles: PropTypes.bool,
    onDidMount: PropTypes.func,
    qaSelector: PropTypes.string,
  };

  static defaultProps = {
    onDidMount: noop,
  };

  componentDidMount() {
    this.props.onDidMount();
  }

  render() {
    const { className, content, isDefaultStyles, qaSelector } = this.props;

    if (!content) {
      return null;
    }

    // CMS scripts can change this markup before hydration (e.g. the header
    // toggles the login links). React keeps the server HTML either way, so the
    // dev-only mismatch warning is noise.
    return (
      <div
        data-qa-selector={qaSelector}
        className={cns(className, { [cn.defaultStyles]: isDefaultStyles })}
        dangerouslySetInnerHTML={{
          __html: content,
        }}
        suppressHydrationWarning
      />
    );
  }
}
